import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { colors } from 'styles/theme';
import { hoverAvailable, mobileOnly, setOpacity } from 'styles/utils';

import ButtonBase from 'components/shared/ButtonBase/ButtonBase';

const btnCss = props => css`
  border-style: solid;
  border-color: transparent;
  border-radius: 2em;
  font-weight: 500;

  ${mobileOnly} {
    :focus {
      outline: 0;
    }
  }

  // Size-related
  ${props.small
    ? css`
        font-size: 1.6rem;
        padding: 7px 15px;
        border-width: 1px;
      `
    : css`
        font-size: 1.8rem;
        padding: 16px 45px;
        border-width: 2px;
      `}
`;

const skinCss = {
  contained: css`
    color: ${colors.white};
    background-color: ${colors.darkPurple};

    ${hoverAvailable} {
      &:hover:not(:disabled) {
        background-color: ${colors.purple};
      }
    }

    &:disabled {
      color: ${setOpacity(colors.white, 0.4)};
    }
  `,
  text: css`
    color: ${colors.purple};

    &:disabled {
      color: ${setOpacity(colors.purple, 0.4)};
    }
  `,
  outlined: css`
    color: ${colors.darkPurple};
    border-color: ${colors.darkPurple};

    ${hoverAvailable} {
      &:hover:not(:disabled) {
        color: ${colors.white};
        background-color: ${colors.purple};
        border-color: ${colors.purple};
      }
    }

    &:disabled {
      opacity: 0.4;
    }
  `,
};

function ButtonNew({ children, skin = 'contained', small, ...restProps }) {
  return (
    <ButtonBase css={[btnCss({ small }), skinCss[skin]]} {...restProps}>
      {children}
    </ButtonBase>
  );
}

ButtonNew.propTypes = {
  children: PropTypes.node,
  skin: PropTypes.oneOf(['contained', 'text', 'outlined']),
  small: PropTypes.bool,
};

export default ButtonNew;
